export const Roles_LIST = 'Roles#LIST';
export const Roles_DELETE = 'Roles#DELETE';
export const Roles_ADD = 'Roles#ADD';
export const Roles_EDIT = 'Roles#EDIT';
export const Users_LIST = 'Users#LIST';
export const Users_EDIT = 'Users#EDIT';
export const Application_LIST = 'Application#LIST';
export const Application_ADD = 'Application#ADD';
export const Application_EDIT = 'Application#EDIT';
export const KnowledgeBase_LIST = 'KnowledgeBase#LIST';
export const KnowledgeBase_IMPORT = 'KnowledgeBase#IMPORT';
export const KnowledgeBase_VIEW = 'KnowledgeBase#VIEW';
export const KnowledgeBase_APPROVE = 'KnowledgeBase#APPROVE';
export const KnowledgeBase_DELETE = 'KnowledgeBase#DELETE';
export const Image_LIST = 'Image#LIST';
export const Image_IMPORT = 'Image#IMPORT';
export const Image_EDIT = 'Image#EDIT';
export const Image_APPROVE = 'Image#APPROVE';
export const Image_DELETE = 'Image#DELETE';
export const ContentReview_LIST = 'Chat#LIST';
export const ContentReview_DETAIL = 'Chat#VIEW';
export const ContentReview_APPROVE = 'Chat#APPROVE';
export const Dashboard = 'Dashboard';
export const Document_LIST = 'Document#LIST';
export const Document_IMPORT = 'Document#IMPORT';
export const Document_EDIT = 'Document#EDIT';
export const Document_DELETE = 'Document#DELETE';